import React from "react"
import { nl2br } from "../../../../utils/string-helpers"
import * as s from './css/descrizione-pacchetto.module.css'

const DescrizionePacchetto = ({ project, descriptionTitleStyle={} }) => {

    return (
        <div className={`container-grid ${s.container}`}>
            <div className="col-span-4 desktop:col-span-6 mx-4 desktop:col-start-4 desktop:mx-0">
                <div className="text-3 leading-9 text-primary font-md" style={descriptionTitleStyle}>{ project.descriptionTitle }</div>
                <div className={`font-rg text-6 desktop:text-8 text-black leading-5 ${s.description}`} dangerouslySetInnerHTML={{ __html: nl2br(project.descriptionContent) }} />
            </div>
        </div>
    )
}

export default DescrizionePacchetto